import { versionSearch } from '@app/const';

/**
 * Pad a version string to the correct number of segments, then increment the final digit.
 *
 * @param version - The version string to increment (e.g., "1.0.0" turns into "1.0.1" or "1.0.0.0" depending on @see isHotfix).
 * @param isHotfix - If true, pad to 4 segments (e.g., "1.0.0.0"). If false pad to 3 segments (e.g., "1.0.0").
 * @returns The incremented @see version string.
 */
export function incrementVersion(version: string, isHotfix = false): string {
  if (
    typeof version !== 'string'
    || !versionSearch.test(version)
  ) {
    throw new Error(`Unable to increment invalid version "${version}".`);
  }

  const expectedLength = (isHotfix) ? 4 : 3;
  const splitVersion = version.split('.');
  while (splitVersion.length < expectedLength) {
    const isLast = splitVersion.length >= (expectedLength - 1);
    // Add -1 as the last one so it becomes 0 when incremented.
    splitVersion.push((isLast) ? '-1' : '0');
  }

  const lastPart = parseInt(splitVersion.pop() ?? '0', 10);
  return [
    ...splitVersion,
    lastPart + 1
  ].join('.');
}
